import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'

import TimetoastPropTypes from '@constants/timetoast_prop_types.js'
import { defaultColorScheme } from '@helpers/color_scheme_helpers.js'

export default class EditableColorPalette extends PureComponent {
  handleChange = event => {
    const { target } = event
    const { onChange } = this.props
    const { name, value } = target
    const changeObj = {
      [name]: value,
    }
    onChange(changeObj)
  }

  render() {
    const { colorScheme, className } = this.props
    return (
      <div
        className={className}
        ref={c => {
          this.paletteRef = c
        }}
      >
        <input
          value={colorScheme.primary}
          onChange={this.handleChange}
          className="color-scheme-customizer__color"
          name="primary"
          aria-label={`Primary color: ${colorScheme.primary}`}
          type="color"
        />
        <input
          value={colorScheme.secondary}
          onChange={this.handleChange}
          className="color-scheme-customizer__color"
          name="secondary"
          aria-label={`Primary color: ${colorScheme.secondary}`}
          type="color"
        />
        <input
          value={colorScheme.tertiary}
          onChange={this.handleChange}
          className="color-scheme-customizer__color"
          name="tertiary"
          aria-label={`Primary color: ${colorScheme.tertiary}`}
          type="color"
        />
        <input
          value={colorScheme.highlight}
          onChange={this.handleChange}
          className="color-scheme-customizer__color"
          name="highlight"
          aria-label={`Primary color: ${colorScheme.highlight}`}
          type="color"
        />
      </div>
    )
  }
}
EditableColorPalette.propTypes = {
  colorScheme: TimetoastPropTypes.colorScheme.isRequired,
  onChange: PropTypes.func.isRequired,
}
EditableColorPalette.defaultProps = {
  colorScheme: defaultColorScheme(),
  onChange: noop,
}
